export default __webpack_public_path__ + "static/media/ghtk.ddc923b0.png";